/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Card,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import ContactSidebar from "./ContactSidebar";
import DatoTab from "./DatoTab";
import { MetaTags } from "react-meta-tags";
import { getContactsRead } from "../../../helpers/backend";
import { useParams } from "react-router-dom";
import ButtonVolver from "../../../components/ButtonVolver";
import "./contact-profile.css";
import EnelTab from "./EnelTab";
import GestionContactoTablaSolo from "../../GestionContacto/GestionContactoTablaSolo";
import CiudadLimpiaTab from "./CiudadLimpiaTab";
import DatosFacturacionTab from "./DatosFacturacionTab";

const ProfileTab = () => {
  const [activeTab, setActiveTab] = useState("1");
  const id = useParams().id;
  const [contact, setContact] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  const getContactData = async () => {
    const response = await getContactsRead(id);
    setContact(response.data);
  };
  console.log(contact);

  useEffect(() => {
    getContactData();
  }, [id]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleSave = () => {
    // Aquí iría la lógica para guardar los cambios
    getContactData(); // Refrescar datos
    setIsEditing(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cuidad Limpia | Perfil del Contacto</title>
        </MetaTags>
        <Container fluid>
          <Col className="d-flex gap-3 mb-4 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Perfil de Contacto
            </span>
          </Col>

          <Row>
            {/* Sidebar con información del contacto */}
            <Col md={5} lg={3}>
              <ContactSidebar
                contact={contact}
                isEditing={isEditing}
                onEditToggle={() => setIsEditing(!isEditing)}
                onSave={handleSave}
              />
            </Col>

            {/* Contenido principal con pestañas */}
            <Col md={8} lg={9}>
              <Card className="profile-tabs-card">
                <Nav pills justified role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => toggle("1")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-home me-2 p-3"></i>
                      Ciudad Limpia
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => toggle("2")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-bolt me-2 p-3"></i>
                      Enel
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => toggle("3")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-address-card me-2 p-3"></i>
                      Datos de Contacto
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "5" })}
                      onClick={() => toggle("5")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-file-invoice-dollar me-2 p-3"></i>
                      Datos de facturación
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "6" })}
                      onClick={() => toggle("6")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fas fa-tasks me-2 p-3"></i>
                      Gestión del contacto
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="p-4">
                  <TabPane tabId="1" style={{ cursor: "pointer" }}>
                    <CiudadLimpiaTab contact={contact} />
                  </TabPane>
                  <TabPane tabId="2">
                    <EnelTab contact={contact} />
                  </TabPane>
                  <TabPane tabId="3" style={{ cursor: "pointer" }}>
                    <DatoTab />
                  </TabPane>
                  <TabPane tabId="5">
                    <DatosFacturacionTab contact={contact} />
                  </TabPane>
                  <TabPane tabId="6">
                    <GestionContactoTablaSolo contactId={contact.id} />
                  </TabPane>
                </TabContent>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProfileTab;